import { render, staticRenderFns } from "./CurationRequest.vue?vue&type=template&id=c63ffbc2&scoped=true"
import script from "./CurationRequest.vue?vue&type=script&lang=js"
export * from "./CurationRequest.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c63ffbc2",
  null
  
)

export default component.exports